import React, { useState } from "react";
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faChainBroken, faTrash, faUnlock, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import BlockModal from "./BlockModal.js";
import MarkDefectiveModal from "./MarkDefectiveModal.js";
import FiltersPartial from './FiltersPartial.js';

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showMarkDefectiveModal, setShowMarkDefectiveModal] = useState(false);
  const [rfidDetails, setRfidDetails] = useState({});
  const [filtersModel, setFiltersModel] = useState({
    statuses: ['active']
  });

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Owner Name',
      attr: 'owner_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Owner Type',
      value: (row) => {
        return <>{ row.owner_type == 'User' ? row.owner_user_type.role_name : row.owner_type }</>
      },
      disableSort: true
    },
    {
      label: 'Serial Number',
      attr: 'serial_no',
    },
    {
      ...defaultHeaderConfig,
      label: 'Model',
      attr: 'model',
      disableSort: true
    },
    {
      label: 'Chip Type',
      attr: 'chip_type',
      disableSort: true
    },
    {
      label: 'Invoice Number',
      attr: 'invoice_number',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Assigned At',
      attr: 'assigned_at',
    },
    {
      label: 'Status',
      value: (row) => {
        switch(row.status){
          case 'active': return <span className="text-success"><FontAwesomeIcon icon={faUserCheck}/> Active</span>
          case 'blocked': return <span className="text-danger"><FontAwesomeIcon icon={faBan}/> Blocked</span>
          case 'defective': return <span className="text-warning"><FontAwesomeIcon icon={faChainBroken}/> Defective</span>
          case 'deleted_by_sap': return <span className="text-secondary"><FontAwesomeIcon icon={faTrash}/> Deleted By SAP</span>
          default: return <span>{row.status}</span>
        }
      },
      disableSort: true
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.block_unblock_rfid_card.name)}>
            {
              row.status === 'blocked' ?
              <div
                style={{cursor: 'pointer'}}
                className='link-info border rounded p-1 bg-info-subtle'
                onClick={(e) => onBlockUnblockClick(row)}
              >
                <FontAwesomeIcon icon={faUnlock}/> Unblock
              </div> :
              row.status !== 'defective' && row.status !== 'deleted_by_sap' ?
              <div
                style={{cursor: 'pointer'}}
                className='link-danger border rounded p-1 bg-danger-subtle'
                onClick={(e) => onBlockUnblockClick(row)}
              >
                <FontAwesomeIcon icon={faBan}/> Block
              </div> :
              <></>
            }
          </UiAction>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.mark_defective_rfid_card.name)}>
            {
              row.status !== 'defective' && row.status !== 'blocked' && row.status !== 'deleted_by_sap' && (row.owner_user_type?.id === 2 || row.owner_user_type?.id === 3) &&
              <div
                style={{cursor: 'pointer'}}
                className='link-danger border rounded p-1 bg-danger-subtle'
                onClick={(e) => onMarkDefectiveClick(row)}
              >
                <FontAwesomeIcon icon={faChainBroken}/> Mark Defective
              </div>
            }
          </UiAction>
        </div>
      }
    }
  ]

  const onBlockUnblockClick = (data) => {
    setRfidDetails(data);
    setShowBlockModal(true);
  }

  const onMarkDefectiveClick = (data) => {
    setRfidDetails(data);
    setShowMarkDefectiveModal(true);
  }

  return <>
    <React.Fragment>
      <BlockModal showBlockModal={showBlockModal} setShowBlockModal={setShowBlockModal} rfidDetails={rfidDetails} />
    </React.Fragment>
    <React.Fragment>
      <MarkDefectiveModal showMarkDefectiveModal={showMarkDefectiveModal} setShowMarkDefectiveModal={setShowMarkDefectiveModal} rfidDetails={rfidDetails} />
    </React.Fragment>
    <ListingPageComponent
      key={PAGES.RfidCardsListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.RfidCardsListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Voltup Id Cards' }]}
      listingMutation={getApi('rfids')}
      className="rfids-listing-page"
      contentHeading="Voltup Id Cards - Results"
      headers={headers}
      recordsKey="rfids"
      searchBy={['Serial Number', 'Invoice Number']}
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
    />
  </>
};

export default Index;
